import { Stack, Typography } from '@mui/material';

export const MFErrorText = () => {
  return (
    <Stack justifyContent="center" alignItems="center" height="100%">
      <Typography textAlign="center">Oops! Looks like you've gotten lost in cyberspace.</Typography>
    </Stack>
  );
};
